import Cookies from 'js-cookie'

const SiteKey = 'siteid'

export function getSite () {
  return Cookies.get(SiteKey)
}

export function setSite (siteid) {
  return Cookies.set(SiteKey, siteid)
}

export function removeSite () {
  return Cookies.remove(SiteKey)
}

export function getCookie (key) {
  return Cookies.get(key)
}

export function setCookie (key, value, hours) {
  if (hours) {
    const inFifteenMinutes = new Date(new Date().getTime() + hours * 60 * 60 * 1000)
    return Cookies.set(key, value, { expires: inFifteenMinutes })
  } else {
    const inFifteenMinutes = new Date(new Date().getTime() + 99999 * 60 * 60 * 1000)
    return Cookies.set(key, value, { expires: inFifteenMinutes })
  }
}

export function removeCookie (key) {
  return Cookies.remove(key)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js